export const LIVE_VISITS_METRICS = {
  allColumns: [
    'reports-timestamp',
    'reports-id',
    'reports-externalid',
    'campaigns-id',
    'campaigns-name',
    'landings-id',
    'landings-name',
    'offers-id',
    'offers-name',
    'flows-id',
    'flows-name',
    'reports-country',
    'traffic_sources-id',
    'traffic_sources-name',
    'affiliate_networks-id',
    'affiliate_networks-name',
    'reports-os',
    'reports-osversion',
    'reports-devicetype',
    'reports-devicevendor',
    'reports-devicemodel',
    'reports-browser',
    'reports-browserversion',
    'reports-isp',
    'reports-mobilecarrier',
    'reports-connecttype',
    'reports-ip',
    'reports-referrer',
    'reports-blacklistedip',
    'reports-datacenterip',
    'live_visits-ip_with_frequent_events',
    'live_visits-ip_with_frequent_campaign_events',
    'reports-custom1',
    'reports-custom2',
    'reports-custom3',
    'reports-custom4',
    'reports-custom5',
    'reports-custom6',
    'reports-custom7',
    'reports-custom8',
    'reports-custom9',
    'reports-custom10',
    'live_reports-cost',
    'reports-costbot',
  ],
  defaultUnselected: [
    'landings-id',
    'landings-name',
    'offers-id',
    'offers-name',
    'flows-id',
    'flows-name',
    'reports-country',
    'traffic_sources-id',
    'traffic_sources-name',
    'affiliate_networks-id',
    'affiliate_networks-name',
    'reports-os',
    'reports-osversion',
    'reports-devicetype',
    'reports-devicevendor',
    'reports-devicemodel',
    'reports-browser',
    'reports-browserversion',
    'reports-isp',
    'reports-mobilecarrier',
    'reports-connecttype',
    'reports-ip',
    'reports-referrer',
    'reports-blacklistedip',
    'reports-datacenterip',
    'reports-custom1',
    'reports-custom2',
    'reports-custom3',
    'reports-custom4',
    'reports-custom5',
    'reports-custom6',
    'reports-custom7',
    'reports-custom8',
    'reports-custom9',
    'reports-custom10',
    'live_visits-ip_with_frequent_events',
    'live_visits-ip_with_frequent_campaign_events',
    'reports-costbot'
  ],
  defaultSelected: [
    'reports-timestamp'
  ],
  defaultSort: [
    'reports-timestamp'
  ],
  order: {
    orderBy: 'reports-timestamp',
    orderDir: 'desc',
  },
  weight: {},
  sortExclude:[
    'reports-id',
    'reports-externalid',
    'campaigns-id',
    'campaigns-name',
    'landings-id',
    'landings-name',
    'offers-id',
    'offers-name',
    'reports-country',
    'traffic_sources-id',
    'traffic_sources-name',
    'affiliate_networks-id',
    'affiliate_networks-name',
    'reports-os',
    'reports-osversion',
    'reports-devicetype',
    'reports-devicevendor',
    'reports-devicemodel',
    'reports-browser',
    'reports-browserversion',
    'reports-isp',
    'reports-mobilecarrier',
    'reports-connecttype',
    'reports-ip',
    'reports-referrer',
    'reports-custom1',
    'reports-custom2',
    'reports-custom3',
    'reports-custom4',
    'reports-custom5',
    'reports-custom6',
    'reports-custom7',
    'reports-custom8',
    'reports-custom9',
    'reports-custom10',
    'reports-blacklistedip',
    'reports-datacenterip',
    'live_reports-cost',
  ],
  metricsFilters:[]
}
